var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "info" }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "lfetCon" }, [
          _c(
            "div",
            { staticClass: "link" },
            _vm._l(_vm.linkGroup, function(item, i) {
              return _c(
                "div",
                { key: i },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.link[i].label,
                        "popper-class": "linkSelect"
                      },
                      on: {
                        change: function(val) {
                          _vm.tolink(val, i)
                        }
                      },
                      model: {
                        value: _vm.link[i],
                        callback: function($$v) {
                          _vm.$set(_vm.link, i, $$v)
                        },
                        expression: "link[i]"
                      }
                    },
                    _vm._l(item, function(el, ind) {
                      return _c("el-option", {
                        key: ind,
                        attrs: { label: el.label, value: ind }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "quickLinks" },
            _vm._l(_vm.quickLink, function(item, i) {
              return _c(
                "div",
                {
                  key: i,
                  on: {
                    click: function($event) {
                      return _vm.pathJumpb(item)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "copy" }, [
            _c("span", [
              _vm._v(
                "COPYRIGHT © 2023-" +
                  _vm._s(_vm.nowYear()) +
                  "\n            长江数联物流信息（湖北）股份有限公司 ALL RIGHTS RESERVED"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ewm" }, [
          _c("div", { staticClass: "code-info" }, [
            _c("img", {
              staticStyle: {
                width: "120px",
                height: "120px",
                "border-radius": "8px"
              },
              attrs: { src: require("../../assets/images/code1.jpg") }
            }),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "code-info" }, [
            _c("img", {
              staticStyle: {
                width: "120px",
                height: "120px",
                "border-radius": "8px"
              },
              attrs: { src: require("../../assets/images/publiccode.jpg") }
            }),
            _vm._v(" "),
            _vm._m(2)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "beian" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://beian.miit.gov.cn/#/Integrated/index"
          }
        },
        [
          _c("span", { staticStyle: { color: "#939393" } }, [
            _vm._v("鄂ICP备2023029374号-1 ")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-all" }, [
      _c("div", { staticClass: "tips-iph" }, [_vm._v("小程序")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-all" }, [
      _c("div", { staticClass: "tips-iph" }, [_vm._v("公众号")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-515b65e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-515b65e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot_nav/index.vue
// module id = null
// module chunks = 